export const HOW_TO_SWITCH_ACCOUNT_URL =
  'https://help.amplorium.com/doc/getting-started/how-to-make-an-instagram-business-account'
export const HELP_PORTAL_PRICING_INFO = 'https://help.amplorium.com/doc/pricing'
const SHOPIFY_APP_HANDLE = 'amplorium'
// The fragment asks the listing to open its review modal; without it the link
// still lands on the listing page.
export const SHOPIFY_APP_REVIEW_URL = `https://apps.shopify.com/${SHOPIFY_APP_HANDLE}#modal-show=ReviewListingModal`
export const POST_DESCRIPTION_DEBOUNCE_TIME = 1000
export const CHATWOOT_WEBSITE_TOKEN = 'icN1aJwxzEuxqtHHptcFJBf1'
export const DEFAULT_ERROR_MESSAGE_KEY = 'common.error' as const
export const SENTRY_DNS =
  window?.location?.hostname === 'localhost'
    ? ''
    : 'https://5b1ee3dd6175df2f29d1fa8713f84128@o4509130316840960.ingest.us.sentry.io/4509130610114560'
